// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DreamEditor__errorMessage___C2TVY {
    color: red;
    margin: 10px;
}

.DreamEditor__formInput___DOvGh {
    text-align: center;
}

.DreamEditor__emotionSelector___B44nd {
    max-width: 54px;
}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"errorMessage": `DreamEditor__errorMessage___C2TVY`,
	"formInput": `DreamEditor__formInput___DOvGh`,
	"emotionSelector": `DreamEditor__emotionSelector___B44nd`
};
module.exports = ___CSS_LOADER_EXPORT___;
